import React from 'react';
import { 
  FaRocket, 
  FaHeadset, 
  FaChartLine, 
  FaDatabase, 
  FaCloud, 
  FaArrowRight,
  FaCogs,
  FaCode,
  FaShieldAlt,
  FaUsers,
  FaCalculator,
  FaBuilding,
  FaShoppingCart,
  FaPlus,
  FaCheck
} from 'react-icons/fa';

const Landing = ({ setPage }) => {
  
  // Simple navigation to products page
  const handleProductClick = (productId) => {
    setPage('products');
    setTimeout(() => {
      const element = document.querySelector('.products');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="landing page-enter">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge-wrapper">
              <span className="hero-badge">
                <FaRocket className="badge-icon" /> Innovation Leader
              </span>
            </div>
            <h1 className="hero-title">
              Empowering <span>Businesses</span> with <br />
              Smart <span>Solutions</span>
            </h1>
            <p className="hero-description">
              Senidek Technology delivers cutting-edge SaaS solutions to streamline
              your operations, boost productivity, and drive growth.
            </p>
            <div className="hero-actions">
              <button className="btn-primary hero-btn" onClick={() => setPage('products')}>
                <FaRocket /> Explore Products
              </button>
              <button className="btn-outline hero-btn" onClick={() => setPage('calculator')}>
                <FaCalculator /> Calculate Cost
              </button>
              <button className="btn-outline hero-btn" onClick={() => setPage('contact')}>
                <FaHeadset /> Get in Touch
              </button>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">150+</span>
                <span className="stat-label">Happy Clients</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <span className="stat-number">98%</span>
                <span className="stat-label">Satisfaction Rate</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Support</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-illustration">
              <div className="illustration-bg">
                <img src="/logo.png" alt="Senidek Technology" className="illustration-logo" />
              </div>
              <div className="floating-icons">
                <FaChartLine className="float-icon f1" />
                <FaDatabase className="float-icon f2" />
                <FaCloud className="float-icon f3" />
              </div>
              <div className="illustration-text">
                <h3>Senidek Platform</h3>
                <p>Complete Business Suite</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Products */}
      <div className="featured-section">
        <div className="featured-container">
          <div className="section-header">
            <span className="section-badge">⭐ Featured Solutions</span>
            <h2>Our Flagship <span>Products</span></h2>
            <p>Click on a product to learn more</p>
          </div>
          <div className="featured-grid">
            <div 
              className="featured-card" 
              onClick={() => handleProductClick('senidek')}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => e.key === 'Enter' && handleProductClick('senidek')}
            >
              <div className="featured-card-icon">
                <img src="/senideksaaslogo.png" alt="Senidek" className="featured-logo" />
              </div>
              <h3>Senidek Sales & Inventory</h3>
              <p>Complete ERP solution with inventory, sales, and analytics</p>
              <div className="featured-tag-group">
                <span className="featured-tag popular">Most Popular</span>
                <span className="featured-arrow"><FaArrowRight /></span>
              </div>
            </div>

            <div 
              className="featured-card" 
              onClick={() => handleProductClick('tarik')}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => e.key === 'Enter' && handleProductClick('tarik')}
            >
              <div className="featured-card-icon tarik-icon">
                <img src="/tarik.png" alt="Yene Tarik" className="featured-logo" />
              </div>
              <h3>Yene Tarik</h3>
              <p style={{ fontSize: '0.95rem' }}>የኔ ታሪክ</p>
              <p style={{ fontSize: '0.8rem', color: '#94a3b8' }}>CV • Portfolio • Catalog Builder</p>
              <div className="featured-tag-group">
                <span className="featured-tag" style={{ background: '#7c3aed' }}>Creative Studio</span>
                <span className="featured-arrow"><FaArrowRight /></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Calculator Section */}
      <div className="calculator-section">
        <div className="calculator-container">
          <div className="calculator-content">
            <div className="calculator-left">
              <span className="calculator-badge">💰 Calculate Your Project Cost</span>
              <h2>Get an Instant <span>Estimate</span></h2>
              <p className="calculator-description">
                Use our interactive calculator to get an instant estimate for your website or 
                custom development project. Select your requirements and see the total cost in real-time.
              </p>
              <div className="calculator-features">
                <div className="calculator-feature">
                  <FaBuilding className="calc-feature-icon" />
                  <div>
                    <h4>Website Types</h4>
                    <p>Basic, E-commerce, Real Estate, Corporate, Portfolio</p>
                  </div>
                </div>
                <div className="calculator-feature">
                  <FaPlus className="calc-feature-icon" />
                  <div>
                    <h4>Additional Pages</h4>
                    <p>9+ page types starting from 1,000 Birr each</p>
                  </div>
                </div>
                <div className="calculator-feature">
                  <FaShoppingCart className="calc-feature-icon" />
                  <div>
                    <h4>Payment Systems</h4>
                    <p>Chapa, International, TeleBirr integration</p>
                  </div>
                </div>
                <div className="calculator-feature">
                  <FaCogs className="calc-feature-icon" />
                  <div>
                    <h4>Pro Services</h4>
                    <p>Blog, Booking, Analytics, SEO, Multi Vendor & more</p>
                  </div>
                </div>
              </div>
              <button className="btn-primary calculator-btn" onClick={() => setPage('calculator')}>
                <FaCalculator /> Calculate Your Project Cost
              </button>
            </div>
            <div className="calculator-right">
              <div className="calculator-illustration">
                <div className="calc-icon-grid">
                  <div className="calc-grid-item"><FaBuilding /></div>
                  <div className="calc-grid-item"><FaShoppingCart /></div>
                  <div className="calc-grid-item"><FaCogs /></div>
                  <div className="calc-grid-item"><FaCalculator /></div>
                </div>
                <div className="calc-illustration-text">
                  <h3>Project Cost Calculator</h3>
                  <p>Get your estimate in seconds</p>
                  <div className="calc-price-preview">
                    <span>Starting from</span>
                    <h4>7,500 Birr</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom ERP Development Section */}
      <div className="erp-section">
        <div className="erp-container">
          <div className="erp-content">
            <div className="erp-left">
              <span className="erp-badge">🏢 Custom Development</span>
              <h2>Build Your <span>Custom ERP</span> Solution</h2>
              <p className="erp-description">
                We develop tailor-made ERP systems designed specifically for your business needs. 
                From inventory management to HR, accounting, and beyond.
              </p>
              <div className="erp-features">
                <div className="erp-feature">
                  <FaCogs className="erp-feature-icon" />
                  <div>
                    <h4>Fully Customizable</h4>
                    <p>Built to match your exact business processes</p>
                  </div>
                </div>
                <div className="erp-feature">
                  <FaCode className="erp-feature-icon" />
                  <div>
                    <h4>Modern Tech Stack</h4>
                    <p>React, PHP, MySQL - Scalable & Secure</p>
                  </div>
                </div>
                <div className="erp-feature">
                  <FaShieldAlt className="erp-feature-icon" />
                  <div>
                    <h4>Enterprise Security</h4>
                    <p>Bank-grade security & data protection</p>
                  </div>
                </div>
                <div className="erp-feature">
                  <FaUsers className="erp-feature-icon" />
                  <div>
                    <h4>User-Friendly</h4>
                    <p>Intuitive interface for your entire team</p>
                  </div>
                </div>
              </div>
              <button className="btn-primary erp-btn" onClick={() => setPage('products')}>
                View ERP Solutions <FaArrowRight />
              </button>
            </div>
            <div className="erp-right">
              <div className="erp-illustration">
                <div className="erp-grid-icon">
                  <div className="grid-item"><FaDatabase /></div>
                  <div className="grid-item"><FaChartLine /></div>
                  <div className="grid-item"><FaUsers /></div>
                  <div className="grid-item"><FaShieldAlt /></div>
                </div>
                <div className="erp-illustration-text">
                  <h3>Custom ERP Solutions</h3>
                  <p>Built for your business</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features-section">
        <div className="features-container">
          <div className="section-header">
            <span className="section-badge">💡 Why Choose Us</span>
            <h2>Built for <span>Success</span></h2>
            <p>Everything you need to grow your business</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-card-icon">🚀</div>
              <h4>Scalable Solutions</h4>
              <p>Grow your business with solutions that scale with you</p>
            </div>
            <div className="feature-card">
              <div className="feature-card-icon">🔒</div>
              <h4>Enterprise Security</h4>
              <p>Bank-grade security to protect your business data</p>
            </div>
            <div className="feature-card">
              <div className="feature-card-icon">⚡</div>
              <h4>Real-time Analytics</h4>
              <p>Make data-driven decisions with instant insights</p>
            </div>
            <div className="feature-card">
              <div className="feature-card-icon">🤝</div>
              <h4>24/7 Support</h4>
              <p>Dedicated support team always ready to help</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section">
        <div className="cta-container">
          <div className="cta-content">
            <h2>Ready to <span>Transform</span> Your Business?</h2>
            <p>Join thousands of businesses already using our solutions</p>
            <button className="btn-primary cta-btn" onClick={() => setPage('contact')}>
              Get Started Today <FaArrowRight />
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .landing {
          padding: 0;
          animation: fadeIn 0.5s ease;
        }

        .hero-section {
          padding: 40px 0 60px;
          position: relative;
          overflow: hidden;
        }

        .hero-section::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 60%;
          height: 150%;
          background: radial-gradient(ellipse, var(--primary-light) 0%, transparent 70%);
          opacity: 0.3;
          pointer-events: none;
        }

        .hero-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
          position: relative;
          z-index: 1;
          padding: 0 20px;
        }

        .hero-content {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .hero-badge-wrapper {
          display: flex;
          align-items: center;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: var(--primary-light);
          color: var(--primary);
          padding: 8px 20px;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          letter-spacing: 0.3px;
        }

        .badge-icon {
          font-size: 0.9rem;
        }

        .hero-title {
          font-size: 3.5rem;
          font-weight: 800;
          line-height: 1.1;
          letter-spacing: -0.03em;
          color: var(--gray-900);
        }

        .hero-title span {
          color: var(--primary);
          position: relative;
        }

        .hero-title span::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 0;
          right: 0;
          height: 6px;
          background: var(--primary-light);
          border-radius: 3px;
          z-index: -1;
        }

        .hero-description {
          font-size: 1.2rem;
          color: var(--gray-500);
          max-width: 500px;
          line-height: 1.8;
        }

        .hero-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 14px;
          margin-top: 8px;
        }

        .hero-btn {
          padding: 16px 36px;
          font-size: 1.05rem;
          min-width: 180px;
          justify-content: center;
        }

        .hero-stats {
          display: flex;
          align-items: center;
          gap: 30px;
          padding-top: 24px;
          border-top: 2px solid var(--gray-100);
          margin-top: 8px;
        }

        .stat-item {
          display: flex;
          flex-direction: column;
        }

        .stat-number {
          font-size: 2rem;
          font-weight: 700;
          color: var(--gray-900);
        }

        .stat-label {
          font-size: 0.85rem;
          color: var(--gray-500);
          font-weight: 500;
        }

        .stat-divider {
          width: 2px;
          height: 40px;
          background: var(--gray-200);
        }

        .hero-visual {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .hero-illustration {
          position: relative;
          width: 100%;
          max-width: 500px;
          aspect-ratio: 1;
        }

        .illustration-bg {
          width: 100%;
          height: 100%;
          border-radius: 40px;
          background: linear-gradient(145deg, #dbeafe, #bfdbfe);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;
        }

        .illustration-logo {
          width: 60%;
          height: 60%;
          object-fit: contain;
          opacity: 0.6;
          filter: grayscale(100%);
        }

        .floating-icons {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          pointer-events: none;
        }

        .float-icon {
          position: absolute;
          font-size: 2.2rem;
          color: var(--primary);
          opacity: 0.2;
          animation: float 4s ease-in-out infinite;
        }

        .float-icon.f1 {
          top: 12%;
          left: 10%;
          animation-delay: 0s;
          font-size: 2.5rem;
        }

        .float-icon.f2 {
          top: 20%;
          right: 12%;
          animation-delay: 0.8s;
          font-size: 2rem;
        }

        .float-icon.f3 {
          bottom: 18%;
          left: 15%;
          animation-delay: 1.6s;
          font-size: 2.8rem;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(5deg); }
        }

        .illustration-text {
          position: absolute;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(10px);
          padding: 16px 32px;
          border-radius: 16px;
          min-width: 200px;
        }

        .illustration-text h3 {
          font-size: 1.4rem;
          font-weight: 700;
          color: var(--gray-900);
        }

        .illustration-text p {
          color: var(--gray-500);
          font-weight: 500;
          font-size: 0.9rem;
        }

        .featured-section {
          padding: 40px 0 60px;
        }

        .featured-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .section-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .section-badge {
          display: inline-block;
          background: var(--primary-light);
          color: var(--primary);
          padding: 6px 20px;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 12px;
          letter-spacing: 0.5px;
        }

        .section-header h2 {
          font-size: 2.6rem;
          font-weight: 800;
          color: var(--gray-900);
        }

        .section-header h2 span {
          color: var(--primary);
          position: relative;
        }

        .section-header h2 span::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 0;
          right: 0;
          height: 4px;
          background: var(--primary-light);
          border-radius: 2px;
          z-index: -1;
        }

        .section-header p {
          color: var(--gray-500);
          font-size: 1.1rem;
          margin-top: 6px;
        }

        .featured-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 28px;
          max-width: 900px;
          margin: 0 auto;
        }

        .featured-card {
          background: white;
          border-radius: 20px;
          padding: 36px 28px;
          text-align: center;
          border: 2px solid var(--gray-200);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .featured-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, var(--primary), var(--accent));
          opacity: 0;
          transition: opacity 0.4s ease;
        }

        .featured-card:hover::before {
          opacity: 1;
        }

        .featured-card:hover {
          border-color: var(--primary);
          transform: translateY(-6px);
          box-shadow: 0 12px 40px rgba(37, 99, 235, 0.12);
        }

        .featured-card:active {
          transform: translateY(-2px);
        }

        .featured-card-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 80px;
          height: 80px;
          background: var(--primary-light);
          border-radius: 20px;
          margin-bottom: 16px;
          transition: transform 0.3s ease;
          overflow: hidden;
        }

        .featured-card:hover .featured-card-icon {
          transform: scale(1.08) rotate(-4deg);
        }

        .featured-card-icon.tarik-icon {
          background: #ede9fe;
        }

        .featured-logo {
          width: 60%;
          height: 60%;
          object-fit: contain;
        }

        .featured-card h3 {
          font-size: 1.3rem;
          font-weight: 700;
          margin-bottom: 8px;
          color: var(--gray-900);
        }

        .featured-card p {
          color: var(--gray-500);
          font-size: 0.95rem;
          margin-bottom: 16px;
          line-height: 1.6;
        }

        .featured-tag-group {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
        }

        .featured-tag {
          display: inline-block;
          padding: 4px 16px;
          border-radius: 50px;
          font-size: 0.7rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .featured-tag.popular {
          background: var(--primary);
          color: white;
        }

        .featured-tag.new {
          background: var(--accent);
          color: white;
        }

        .featured-arrow {
          color: var(--primary);
          font-size: 1.2rem;
          opacity: 0;
          transform: translateX(-10px);
          transition: all 0.3s ease;
        }

        .featured-card:hover .featured-arrow {
          opacity: 1;
          transform: translateX(0);
        }

        /* ===== CALCULATOR SECTION ===== */
        .calculator-section {
          padding: 60px 0;
          background: linear-gradient(180deg, white, var(--gray-50));
        }

        .calculator-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .calculator-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
          background: white;
          border-radius: 30px;
          padding: 50px;
          border: 2px solid var(--gray-200);
          box-shadow: 0 8px 30px rgba(0,0,0,0.04);
          position: relative;
          overflow: hidden;
        }

        .calculator-content::before {
          content: '';
          position: absolute;
          top: -30%;
          right: -10%;
          width: 50%;
          height: 150%;
          background: radial-gradient(ellipse, #fef3c7 0%, transparent 70%);
          opacity: 0.15;
          pointer-events: none;
        }

        .calculator-left {
          position: relative;
          z-index: 1;
        }

        .calculator-badge {
          display: inline-block;
          background: #fef3c7;
          color: #d97706;
          padding: 6px 18px;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 16px;
          letter-spacing: 0.3px;
        }

        .calculator-left h2 {
          font-size: 2.4rem;
          font-weight: 800;
          color: var(--gray-900);
          margin-bottom: 12px;
        }

        .calculator-left h2 span {
          color: var(--primary);
          position: relative;
        }

        .calculator-left h2 span::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 0;
          right: 0;
          height: 4px;
          background: var(--primary-light);
          border-radius: 2px;
          z-index: -1;
        }

        .calculator-description {
          font-size: 1.05rem;
          color: var(--gray-500);
          line-height: 1.8;
          margin-bottom: 24px;
        }

        .calculator-features {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-bottom: 28px;
        }

        .calculator-feature {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 10px 12px;
          border-radius: 10px;
          background: var(--gray-50);
          transition: all 0.3s ease;
        }

        .calculator-feature:hover {
          background: var(--primary-light);
        }

        .calc-feature-icon {
          font-size: 1.2rem;
          color: var(--primary);
          margin-top: 2px;
          flex-shrink: 0;
        }

        .calculator-feature h4 {
          font-size: 0.9rem;
          font-weight: 600;
          color: var(--gray-800);
        }

        .calculator-feature p {
          font-size: 0.75rem;
          color: var(--gray-500);
        }

        .calculator-btn {
          padding: 14px 32px;
          font-size: 1rem;
          width: 100%;
          justify-content: center;
        }

        .calculator-btn svg {
          font-size: 1.1rem;
        }

        .calculator-right {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          z-index: 1;
        }

        .calculator-illustration {
          width: 100%;
          max-width: 380px;
          background: linear-gradient(145deg, #fef3c7, #fde68a);
          border-radius: 30px;
          padding: 40px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .calc-icon-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
          margin-bottom: 20px;
        }

        .calc-grid-item {
          background: white;
          padding: 16px;
          border-radius: 14px;
          font-size: 1.8rem;
          color: var(--primary);
          box-shadow: 0 4px 12px rgba(0,0,0,0.06);
          transition: transform 0.3s ease;
        }

        .calc-grid-item:hover {
          transform: scale(1.05);
        }

        .calc-illustration-text h3 {
          font-size: 1.2rem;
          font-weight: 700;
          color: var(--gray-900);
        }

        .calc-illustration-text p {
          color: var(--gray-600);
          font-weight: 500;
          font-size: 0.9rem;
        }

        .calc-price-preview {
          margin-top: 12px;
          padding: 12px;
          background: white;
          border-radius: 12px;
        }

        .calc-price-preview span {
          font-size: 0.8rem;
          color: var(--gray-500);
          display: block;
        }

        .calc-price-preview h4 {
          font-size: 1.8rem;
          font-weight: 800;
          color: var(--primary);
        }

        /* ===== ERP SECTION ===== */
        .erp-section {
          padding: 60px 0;
          background: var(--gray-50);
        }

        .erp-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .erp-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
          background: white;
          border-radius: 30px;
          padding: 50px;
          border: 2px solid var(--gray-200);
          box-shadow: 0 8px 30px rgba(0,0,0,0.04);
          position: relative;
          overflow: hidden;
        }

        .erp-content::before {
          content: '';
          position: absolute;
          top: -30%;
          right: -10%;
          width: 50%;
          height: 150%;
          background: radial-gradient(ellipse, var(--primary-light) 0%, transparent 70%);
          opacity: 0.1;
          pointer-events: none;
        }

        .erp-left {
          position: relative;
          z-index: 1;
        }

        .erp-badge {
          display: inline-block;
          background: #fef3c7;
          color: #d97706;
          padding: 6px 18px;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 16px;
          letter-spacing: 0.3px;
        }

        .erp-left h2 {
          font-size: 2.4rem;
          font-weight: 800;
          color: var(--gray-900);
          margin-bottom: 12px;
        }

        .erp-left h2 span {
          color: var(--primary);
          position: relative;
        }

        .erp-left h2 span::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 0;
          right: 0;
          height: 4px;
          background: var(--primary-light);
          border-radius: 2px;
          z-index: -1;
        }

        .erp-description {
          font-size: 1.05rem;
          color: var(--gray-500);
          line-height: 1.8;
          margin-bottom: 24px;
        }

        .erp-features {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 28px;
        }

        .erp-feature {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 12px;
          border-radius: 12px;
          background: var(--gray-50);
          transition: all 0.3s ease;
        }

        .erp-feature:hover {
          background: var(--primary-light);
        }

        .erp-feature-icon {
          font-size: 1.3rem;
          color: var(--primary);
          margin-top: 2px;
          flex-shrink: 0;
        }

        .erp-feature h4 {
          font-size: 0.95rem;
          font-weight: 600;
          color: var(--gray-800);
        }

        .erp-feature p {
          font-size: 0.8rem;
          color: var(--gray-500);
        }

        .erp-btn {
          padding: 14px 32px;
          font-size: 1rem;
        }

        .erp-btn span {
          margin-left: 8px;
        }

        .erp-right {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          z-index: 1;
        }

        .erp-illustration {
          width: 100%;
          max-width: 400px;
          background: linear-gradient(145deg, #dbeafe, #bfdbfe);
          border-radius: 30px;
          padding: 40px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .erp-grid-icon {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
          margin-bottom: 20px;
        }

        .grid-item {
          background: white;
          padding: 20px;
          border-radius: 16px;
          font-size: 2rem;
          color: var(--primary);
          box-shadow: 0 4px 12px rgba(0,0,0,0.06);
          transition: transform 0.3s ease;
        }

        .grid-item:hover {
          transform: scale(1.05);
        }

        .erp-illustration-text h3 {
          font-size: 1.3rem;
          font-weight: 700;
          color: var(--gray-900);
        }

        .erp-illustration-text p {
          color: var(--gray-500);
          font-weight: 500;
        }

        /* ===== FEATURES SECTION ===== */
        .features-section {
          padding: 40px 0 60px;
          background: var(--gray-50);
        }

        .features-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 24px;
          max-width: 1000px;
          margin: 0 auto;
        }

        .feature-card {
          background: white;
          padding: 32px 24px;
          border-radius: 16px;
          text-align: center;
          border: 1px solid var(--gray-200);
          transition: all 0.3s ease;
        }

        .feature-card:hover {
          border-color: var(--primary-light);
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
        }

        .feature-card-icon {
          font-size: 2.5rem;
          margin-bottom: 12px;
        }

        .feature-card h4 {
          font-size: 1.05rem;
          font-weight: 600;
          margin-bottom: 6px;
          color: var(--gray-800);
        }

        .feature-card p {
          font-size: 0.9rem;
          color: var(--gray-500);
          line-height: 1.6;
        }

        /* ===== CTA SECTION ===== */
        .cta-section {
          padding: 60px 0;
        }

        .cta-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .cta-content {
          background: linear-gradient(135deg, var(--primary), var(--accent));
          border-radius: 30px;
          padding: 60px 40px;
          text-align: center;
          color: white;
          position: relative;
          overflow: hidden;
        }

        .cta-content::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 60%;
          height: 200%;
          background: radial-gradient(ellipse, rgba(255,255,255,0.1) 0%, transparent 70%);
          pointer-events: none;
        }

        .cta-content h2 {
          font-size: 2.6rem;
          font-weight: 800;
          margin-bottom: 12px;
          position: relative;
          z-index: 1;
        }

        .cta-content h2 span {
          color: #fcd34d;
        }

        .cta-content p {
          font-size: 1.15rem;
          opacity: 0.9;
          margin-bottom: 28px;
          position: relative;
          z-index: 1;
        }

        .cta-btn {
          background: white;
          color: var(--primary);
          padding: 16px 40px;
          font-size: 1.1rem;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
          position: relative;
          z-index: 1;
        }

        .cta-btn:hover {
          background: #f8fafc;
          transform: translateY(-3px);
          box-shadow: 0 8px 30px rgba(0,0,0,0.2);
        }

        .cta-btn span {
          margin-left: 8px;
        }

        @media (max-width: 1024px) {
          .hero-container {
            grid-template-columns: 1fr;
            gap: 40px;
            text-align: center;
          }
          .hero-description { max-width: 100%; }
          .hero-actions { justify-content: center; }
          .hero-stats { justify-content: center; }
          .hero-title { font-size: 2.8rem; }
          .hero-illustration { max-width: 400px; }
          .calculator-content { grid-template-columns: 1fr; padding: 30px; }
          .calculator-features { grid-template-columns: 1fr; }
          .erp-content { grid-template-columns: 1fr; padding: 30px; }
          .erp-features { grid-template-columns: 1fr; }
          .features-grid { grid-template-columns: repeat(2, 1fr); }
        }

        @media (max-width: 768px) {
          .hero-title { font-size: 2.2rem; }
          .hero-description { font-size: 1rem; }
          .hero-stats { flex-wrap: wrap; gap: 16px; }
          .stat-divider { display: none; }
          .featured-grid { grid-template-columns: 1fr; max-width: 450px; }
          .features-grid { grid-template-columns: 1fr 1fr; gap: 16px; }
          .cta-content { padding: 40px 24px; }
          .cta-content h2 { font-size: 2rem; }
          .hero-actions { flex-direction: column; align-items: center; }
          .hero-btn { width: 100%; max-width: 300px; }
          .calculator-content { padding: 24px; }
          .calculator-left h2 { font-size: 1.8rem; }
          .calculator-illustration { max-width: 100%; }
          .erp-content { padding: 24px; }
          .erp-left h2 { font-size: 1.8rem; }
          .calc-icon-grid { grid-template-columns: repeat(2, 1fr); }
        }

        @media (max-width: 480px) {
          .hero-section { padding: 20px 0 40px; }
          .hero-title { font-size: 1.8rem; }
          .hero-title span::after { height: 4px; }
          .hero-stats { flex-direction: column; gap: 12px; align-items: center; }
          .stat-number { font-size: 1.6rem; }
          .features-grid { grid-template-columns: 1fr; }
          .featured-card { padding: 24px 20px; }
          .featured-card-icon { width: 64px; height: 64px; }
          .illustration-text { padding: 12px 20px; min-width: 150px; }
          .illustration-text h3 { font-size: 1.1rem; }
          .cta-content h2 { font-size: 1.6rem; }
          .cta-btn { padding: 14px 28px; font-size: 1rem; width: 100%; }
          .calculator-content { padding: 20px; }
          .calculator-left h2 { font-size: 1.4rem; }
          .calculator-illustration { padding: 20px; }
          .calc-grid-item { padding: 12px; font-size: 1.5rem; }
          .erp-content { padding: 20px; }
          .erp-left h2 { font-size: 1.4rem; }
          .erp-illustration { padding: 20px; }
          .grid-item { padding: 12px; font-size: 1.5rem; }
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default Landing;